import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import './picker.scss';

import Autocomplete from 'react-google-autocomplete';

class Picker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      long: '00.000',
      lat: '00.000',
      mercator: {
        x: null,
        y: null
      },
    }

    this.handleButtonSubmit = this.handleButtonSubmit.bind(this);
  }

  handleButtonSubmit(event) {
    event.preventDefault();
    console.log("button was clicked");
    const lat = sessionStorage.getItem('lat');
    const long = sessionStorage.getItem('long');
    this.props.history.push(`/picker/results?lat=${lat}&long=${long}`)
  }

  componentDidMount = () => {
    // const qs = require('query-string');
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).orguuid
    if (parsed) {
      sessionStorage.setItem('org_uuid', parsed);
    }
    // this.setState({
    //   organization_uuid: parsed
    // })
  }

  logState = () => {
    console.log('[state]', this.state)
  }

  render() {
    return (
      <div>
        <div className="container mt-5">
          <div className="row mt-5">
            <div className="col-md-12 mt-5">
              <h1 className="mb-3">Please enter your address</h1>

              <Autocomplete
                className="form-control"
                onPlaceSelected={(place) => {
                  sessionStorage.setItem('lat', place.geometry.location.lat());
                  sessionStorage.setItem('long', place.geometry.location.lng());
                }}
                types={['address']}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <a href="#" className="btn btn-primary mt-3" onClick={this.handleButtonSubmit}>Continue</a>
              {/* <button onClick={this.logState}>state</button> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect()(Picker);



// WEBPACK FOOTER //
// ./src/components/Picker/Picker.js